<div class="item-page-field">
  <ds-metadata-values
    [mdValues]="filteredValues"
    [separator]="separator"
    [label]="label"
    [enableMarkdown]="enableMarkdown"
  ></ds-metadata-values>
</div>
